@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div
  cdkDrag
  class="add_edit_common_main popup_main_div add_edit_chrone_item_main"
  cdkDragRootElement=".cdk-overlay-pane"
>
  <h2 cdkDragHandle mat-dialog-title class="title-withswitch">
    <span>{{ dialogTitle }}</span>
    <mat-slide-toggle (change)="ToggleForUpadte()">Show Template Fields</mat-slide-toggle>
    <button class="btn" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content class="mat-typography main">
    <div class="one" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
      <form [formGroup]="ChroneItem" fxLayout="column" fxFlex="1 0 auto" name="form">
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
            <mat-label>Format</mat-label>
            <mat-select
              #value
              name="selected"
              (selectionChange)="FormatChange($event.value)"
              [(ngModel)]="ChronologyADD.FORMAT"
              formControlName="Format"
            >
              <mat-option value="1">dd mmm yyyy</mat-option>
              <mat-option value="2">dd mmm yyyy - dd mmm yyyy</mat-option>
              <mat-option value="3">mmm yyyy</mat-option>
              <mat-option value="4">mmm yyyy - mmm yyyy</mat-option>
              <mat-option value="5">yyyy</mat-option>
              <mat-option value="6">yyyy - yyyy</mat-option>
              <mat-option value="7">dd mmm yyyy hh:mm</mat-option>
              <mat-option value="8">dd mmm yyyy hh:mm - hh:mm</mat-option>
            </mat-select>
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList ? $safeNavigationMigration(toolTipList?.FORMAT?.COPYVALUE) : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.FORMAT?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="50"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.DATEFROM),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DATEFROM),
            }"
          >
            <mat-label>Date From</mat-label>
            <input
              (dateInput)="choosedDateForm('input', $event)"
              (dateChange)="choosedDateForm('change', $event)"
              matInput
              [(ngModel)]="ChronologyADD.DATEFROM"
              formControlName="dateForm"
              [matDatepicker]="picker"
              [max]="ChroneItem.get('dateto')?.value || ChronologyADD.DATETO"
              [errorStateMatcher]="dateRangeMatcher"
              matTooltip="{{ toolTipList ? toolTipList?.DATEFROM?.HOVER : '' }}"
              [matTooltipPosition]="toolTipPostion"
            />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList ? $safeNavigationMigration(toolTipList?.DATEFROM?.COPYVALUE) : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.DATEFROM?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field
            class="example"
            appearance="outline"
            fxFlex="34"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.TIMEFROM),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TIMEFROM),
            }"
          >
            <mat-label>Time From</mat-label>
            <input
              #timeFromInput
              matInput
              [(ngModel)]="ChronologyADD.TIMEFROM"
              formControlName="timeForm"
              type="time"
              matTooltip="{{ toolTipList ? toolTipList?.TIMEFROM?.HOVER : '' }}"
              [matTooltipPosition]="toolTipPostion"
            />
            <mat-icon
              matSuffix
              (click)="$event.stopPropagation(); timeFromInput.showPicker()"
              style="cursor: pointer"
            >
              access_time
            </mat-icon>
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList ? $safeNavigationMigration(toolTipList?.TIMEFROM?.COPYVALUE) : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.TIMEFROM?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="33"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.DATETO),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DATETO),
            }"
          >
            <mat-label>Date To</mat-label>
            <input
              [(ngModel)]="ChronologyADD.DATETO"
              (dateInput)="choosedDateTo('input', $event)"
              (dateChange)="choosedDateTo('change', $event)"
              matInput
              formControlName="dateto"
              [matDatepicker]="picker2"
              disabled
              [min]="ChroneItem.get('dateForm')?.value || ChronologyADD.DATEFROM"
              [errorStateMatcher]="dateRangeMatcher"
              matTooltip="{{ toolTipList ? toolTipList?.DATETO?.HOVER : '' }}"
              [matTooltipPosition]="toolTipPostion"
            />
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            @if (ChroneItem.hasError('dateRange')) {
              <mat-error>From Date cannot be later than To Date</mat-error>
            }
            <mat-datepicker #picker2></mat-datepicker>
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList ? $safeNavigationMigration(toolTipList?.DATETO?.COPYVALUE) : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.DATETO?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>

          <mat-form-field
            class="example"
            appearance="outline"
            fxFlex="33"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.TIMETO),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TIMETO),
            }"
          >
            <mat-label>Time To</mat-label>
            <input
              #timeToInput
              [(ngModel)]="ChronologyADD.TIMETO"
              matInput
              formControlName="timeto"
              type="time"
              matTooltip="{{ toolTipList ? toolTipList?.TIMETO?.HOVER : '' }}"
              [matTooltipPosition]="toolTipPostion"
            />
            <mat-icon
              matSuffix
              (click)="$event.stopPropagation(); timeToInput.showPicker()"
              style="cursor: pointer"
            >
              access_time
            </mat-icon>
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList ? $safeNavigationMigration(toolTipList?.TIMETO?.COPYVALUE) : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.TIMETO?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
            <mat-label>Reference</mat-label>
            <input
              matInput
              [(ngModel)]="ChronologyADD.REFERENCE"
              formControlName="Reference"
              matTooltip="{{ toolTipList ? toolTipList?.REFERENCE?.HOVER : '' }}"
              [matTooltipPosition]="toolTipPostion"
            />
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList ? $safeNavigationMigration(toolTipList?.REFERENCE?.COPYVALUE) : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.REFERENCE?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
            <mat-label>Brief Pg#</mat-label>
            <input
              matInput
              [(ngModel)]="ChronologyADD.BRIEFPAGENO"
              formControlName="brif"
              matTooltip="{{ toolTipList ? toolTipList.BRIEFPAGENO?.HOVER : '' }}"
              [matTooltipPosition]="toolTipPostion"
            />
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList ? $safeNavigationMigration(toolTipList?.BRIEFPAGENO?.COPYVALUE) : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.BRIEFPAGENO?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
            <mat-label>Witnesses</mat-label>
            <input
              matInput
              [(ngModel)]="ChronologyADD.WITNESSES"
              formControlName="Witnesses"
              matTooltip="{{ toolTipList ? toolTipList?.WITNESSES?.HOVER : '' }}"
              [matTooltipPosition]="toolTipPostion"
            />
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList ? $safeNavigationMigration(toolTipList?.WITNESSES?.COPYVALUE) : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.WITNESSES?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>

          <!-- <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
          <mat-label>COMMENT</mat-label>
          <textarea [(ngModel)]="ChronologyADD.COMMENT" formControlName="COMMENT" matInput matTooltip="{{(toolTipList)?toolTipList?.COMMENT?.HOVER:''}}" [matTooltipPosition]="toolTipPostion"></textarea>
          <div  *ngIf="testBool && toolTipList" class="tooltip-wrap" (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.COMMENT?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.COMMENT?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div>

        </mat-form-field> -->

          <mat-form-field appearance="outline" fxFlex="100" class="full-width pr-1">
            <mat-label>Comment</mat-label>

            <textarea
              matInput
              [(ngModel)]="ChronologyADD.COMMENT"
              formControlName="COMMENT"
              rows="2"
              cdkTextareaAutosize
              cdkAutosizeMinRows="3"
              cdkAutosizeMaxRows="10"
              [matTooltip]="
                toolTipList ? $safeNavigationMigration(toolTipList?.COMMENT?.HOVER) : ''
              "
              [matTooltipPosition]="toolTipPostion"
              (keydown.enter)="$event.stopImmediatePropagation()"
            ></textarea>
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList ? $safeNavigationMigration(toolTipList?.COMMENT?.COPYVALUE) : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.COMMENT?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>

          <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
          &nbsp;&nbsp;&nbsp;&nbsp;
          <mat-checkbox [(ngModel)]="ChronologyADD.PRIVILEGED" formControlName="Privileged">
            Privileged
          </mat-checkbox>
        </div>

        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <!-- <mat-form-field class="example" appearance="outline" fxFlex="33" class="pr-1"
        [ngClass]="{'has-error':errorWarningData.Error?.NOTE,'has-warning':errorWarningData.Warning?.NOTE}">
        <mat-label>Text</mat-label>
        <input matInput [(ngModel)]="ChronologyADD.ADDITIONALTEXT" formControlName="text" matTooltip="{{(toolTipList)?toolTipList.ADDITIONALTEXT:''}}" [matTooltipPosition]="toolTipPostion" >
        <div  *ngIf="testBool && toolTipList" class="tooltip-wrap" ><input id="myInput"  readonly disabled value="{{toolTipList?.SUBJECT?.COPYVALUE}}"><mat-icon (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.SUBJECT?.COPYVALUE:'')">file_copy</mat-icon></div>

      </mat-form-field> -->

          <mat-form-field class="example" appearance="outline" fxFlex="50" class="pr-1">
            <mat-label>Topic</mat-label>
            <input
              matInput
              [(ngModel)]="ChronologyADD.TOPIC"
              formControlName="topic"
              matTooltip="{{ toolTipList ? toolTipList?.TOPIC?.HOVER : '' }}"
              [matTooltipPosition]="toolTipPostion"
            />
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList ? $safeNavigationMigration(toolTipList?.TOPIC?.COPYVALUE) : ''
                  )
                "
              >
                <input id="myInput" readonly disabled value="{{ toolTipList?.TOPIC?.COPYVALUE }}" />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
            <mat-label>Event Agreed</mat-label>
            <!-- <mat-select #value name="selected" (selectionChange)="Event()" [(ngModel)]="ChronologyADD.EVENTAGREED" formControlName="eventAgereed"  matTooltip="{{(toolTipList)?toolTipList.EVENTAGREED:''}}" [matTooltipPosition]="toolTipPostion">
        <mat-option value="1">Agreed</mat-option>
        <mat-option value="2">Disputed by Plaintiff</mat-option>
        <mat-option value="3">Disputed by Defendant</mat-option>
        <mat-option value="4">Uncertain - required investigation</mat-option>
      </mat-select> -->

            <mat-select
              #value
              name="selected"
              (ngModelChange)="Event1($event)"
              [(ngModel)]="ChronologyADD.EVENTAGREED"
              formControlName="eventAgereed"
            >
              @for (user of userList; track user) {
                <mat-option value="{{ user.LOOKUPGUID }}">
                  {{ user.LOOKUPFULLVALUE }}
                </mat-option>
              }
            </mat-select>
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList ? $safeNavigationMigration(toolTipList?.EVENTAGREED?.COPYVALUE) : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.EVENTAGREED?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field appearance="outline" fxFlex="100" class="pr-1">
            <mat-label>Document Website</mat-label>
            <input
              [(ngModel)]="ChronologyADD.DOCUMENTNAME"
              formControlName="document"
              matInput
              matTooltip="{{ toolTipList ? toolTipList?.DOCUMENTNAME?.HOVER : '' }}"
              [matTooltipPosition]="toolTipPostion"
            />
            <mat-icon matSuffix [matMenuTriggerFor]="menu">
              <img
                src="assets/icons/web_app/Matter Folder Icon.svg"
                alt=""
                matTooltip=""
                matTooltipPosition="above"
                class="block h-full w-full"
              />
            </mat-icon>
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList
                      ? $safeNavigationMigration(toolTipList?.DOCUMENTNAME?.COPYVALUE)
                      : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.DOCUMENTNAME?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
          <mat-menu #menu="matMenu" xPosition="before" yPosition="above">
            <button (click)="documentRegPopup()" mat-menu-item>
              Choose from Document Register
            </button>
            <button (click)="uploader.click()" mat-menu-item>Choose from device</button>
          </mat-menu>
          <!-- File Upload hiddenfiled -->
          <input type="file" hidden #uploader (change)="selectDoc($event)" />
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <!-- <mat-form-field class="example" appearance="outline" fxFlex="100" class="pr-1"
    [ngClass]="{'has-error':errorWarningData.Error?.NOTE,'has-warning':errorWarningData.Warning?.NOTE}">
    <mat-label>Text</mat-label>
    <textarea matInput [(ngModel)]="ChronologyADD.ADDITIONALTEXT" formControlName="text" matTooltip="{{(toolTipList)?toolTipList?.ADDITIONALTEXT?.HOVER:''}}" [matTooltipPosition]="toolTipPostion" ></textarea>
    <div  *ngIf="testBool && toolTipList" class="tooltip-wrap" (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.ADDITIONALTEXT?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.ADDITIONALTEXT?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div>

  </mat-form-field> -->

          <mat-form-field
            appearance="outline"
            fxFlex="100"
            class="full-width pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.NOTE),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.NOTE),
            }"
          >
            <mat-label>Text</mat-label>

            <textarea
              matInput
              [(ngModel)]="ChronologyADD.ADDITIONALTEXT"
              formControlName="text"
              rows="4"
              cdkTextareaAutosize
              cdkAutosizeMinRows="3"
              cdkAutosizeMaxRows="10"
              [matTooltip]="
                toolTipList ? $safeNavigationMigration(toolTipList?.ADDITIONALTEXT?.HOVER) : ''
              "
              [matTooltipPosition]="toolTipPostion"
              (keydown.enter)="$event.stopImmediatePropagation()"
            ></textarea>
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList
                      ? $safeNavigationMigration(toolTipList?.ADDITIONALTEXT?.COPYVALUE)
                      : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.ADDITIONALTEXT?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>
  <mat-dialog-actions class="popup_ftr justify-end!">
    @if (action === 'new') {
      <button
        matButton="filled"
        class="mat-accent"
        (click)="ChroneItemSave()"
        [disabled]="isspiner || ChroneItem.hasError('dateRange')"
      >
        @if (isspiner) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Save
      </button>
    }
    @if (action === 'edit') {
      <button
        matButton="filled"
        class="mat-accent"
        (click)="ChroneItemSave()"
        [disabled]="isspiner || ChroneItem.hasError('dateRange')"
      >
        @if (isspiner) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Update
      </button>
    }
    @if (action !== 'new' && action !== 'edit') {
      <button
        matButton="filled"
        class="mat-accent"
        (click)="ChroneItemSave()"
        [disabled]="isspiner || ChroneItem.hasError('dateRange')"
      >
        @if (isspiner) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Duplicate
      </button>
    }
    <button matButton="tonal" [mat-dialog-close]="false" cdkFocusInitial>Don't Save</button>
  </mat-dialog-actions>
</div>
